<template>
  <div class="tour-mobile-image">
    <picture>
      <!-- will pad images if height > width -->
      <img
        v-if="index === 0"
        width="600"
        height="400"
        class="slider-image"
        :alt="image.description"
        :src="
          getContentfulImgURL({
            url: image.url,
            width: 600,
            height: 400,
            quality: 90,
            fit: 'pad',
            bgColor: 'rgb:000000'
          })
        "
      >
      <img
        v-else
        width="600"
        height="400"
        class="slider-image lazyload"
        :alt="image.description"
        :data-src="
          getContentfulImgURL({
            url: image.url,
            width: 600,
            height: 400,
            quality: 90,
            fit: 'pad',
            bgColor: 'rgb:000000'
          })
        "
      >
    </picture>
    <div class="image-caption">
      <span>
        {{ image.title }}
      </span>
    </div>
  </div>
</template>
<script>
import imageOptimo from "~/mixins/imageOptimoMixin.js"

export default {
  name: "TourMobleImg",
  mixins: [imageOptimo],
  props: {
    image: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
  }
};
</script>

<style lang="scss" scoped>
.tour-mobile-image {
  position: relative;
  height: auto;
  width: 100%;
  overflow: hidden;
  flex-shrink: 0;
  scroll-snap-align: center;
  background-color: black;
  picture {
    box-sizing: border-box;
    object-position: center;
    .slider-image,
    div {
      height: auto;
      width: 100%;
      max-width: 100%;
      max-height: 100%;
      -o-object-fit: cover;
      object-fit: cover;
      object-position: center;
      box-sizing: border-box;
    }
  }
  .image-caption {
    position: absolute;
    width: 100%;
    bottom: 0;
    padding: 16px;
    background-color: rgba(0, 0, 0, 0.75);
    color: white;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    height: 64px;
    @include max-width($mobile) {
      display: block;
      position: relative;
      background-color: #212529;
    }
  }
  span {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
}
</style>
